import React, { FunctionComponent, useContext } from "react"; // importing FunctionComponent
import { getRoute, routes } from "src/AppRouter";
import { AppContext } from "src/contexts/appContext";
import { OfferSwissRH } from "src/types/ApiItems";
import { AppNewsType } from "src/types/dataTypes";
import { List } from "src/components/organisms/lists/list/list";
import { ListItem } from "../../listItem/listItem";

type SwissOffersProps = {
  offers: Array<OfferSwissRH>;
  type: AppNewsType;
  badgeBorderLess?: boolean;
}
export const SwissOffers: FunctionComponent<SwissOffersProps> = ({ offers, type, badgeBorderLess }) => {
  const allOffers = offers.length
    ? offers.map((offer, index) => {
      return (
        <ListItem
          overtitle={"Nous recherchons"}
          title={offer.title}
          classModifier={type}
          date={offer.publishingStartDate ? offer.publishingStartDate : undefined}
          externalLink={offer.uri}
          key={index}
          newLabel={offer.isNew ? "new" : undefined}
          tag={offer.location}
          imgPlaceholder="/newsrh-placeholder.svg"
          badgeBorderLess={badgeBorderLess}
        />
      );
    })
    : "";
  return <List>{allOffers}</List>;
};

SwissOffers.defaultProps = {};
